function checkAllValuesIndexation(indexation, indexationSave) {
  return !(indexation.pourcentageIndexationParDefaut
    !== indexationSave.pourcentageIndexationParDefaut
    || indexation.applicableLocation !== indexationSave.applicableLocation
    || indexation.applicableTlpe !== indexationSave.applicableTlpe
    || indexation.applicableDivers !== indexationSave.applicableDivers
    || indexation.applicableHonoraire !== indexationSave.applicableHonoraire);
}

function checkAllValuesIndexationTiers(indexation, indexationToCompare) {
  let returnValue = true;
  indexation.indexationTiers.forEach((ind) => {
    const indFind = indexationToCompare.indexationTiers.find((indToCompare) => {
      return indToCompare.tiersId === ind.tiersId
        && indexation.annee === indexationToCompare.annee
        && indToCompare.specialisationTiersId === ind.specialisationTiersId
        && indToCompare.pourcentageIndexationParDefaut === ind.pourcentageIndexationParDefaut;
    });
    if (!indFind) returnValue = false;
  });
  return returnValue;
}

export default function checkUpdateOrNotIndexation(indexation, indexationSave) {
  if (!indexationSave && indexation) return false;
  if (!indexation) return true;
  if (indexationSave.indexationTiers.length !== indexation.indexationTiers.length) {
    return false;
  }
  if (!checkAllValuesIndexation(indexation, indexationSave)) return false;
  if (!checkAllValuesIndexationTiers(indexation, indexationSave)) return false;
  return checkAllValuesIndexationTiers(indexationSave, indexation);
}
